// Single chokepoint for REACT_APP_* env reads. Never touch process.env elsewhere.
// Per-org values belong in FinderConfig, not here.

/** Returns the trimmed env value, or '' when missing/blank. Never undefined. */
export const getEnv = (key: string): string => {
  const raw = process.env[key];
  if (typeof raw !== 'string') return '';
  return raw.trim();
};

export const env = {
  publicUrl: getEnv('PUBLIC_URL'),
  apiBaseUrl: getEnv('REACT_APP_API_BASE_URL'),
  googleMapsApiKey: getEnv('REACT_APP_GOOGLE_MAPS_API_KEY'),
  posthogToken: getEnv('REACT_APP_POSTHOG_TOKEN'),
  sentryDsn: getEnv('REACT_APP_SENTRY_DSN'),
} as const;
